/**
 * Settings Service (Frontend Web) - Read-only access to app settings
 */

const API_BASE = import.meta.env.VITE_API_URL || 'https://apicabaza.creago.be';

// In-memory cache for settings (avoids repeated API calls)
let settingsCache = null;
let cacheTimestamp = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

/**
 * Get a setting value by code for a specific language
 * @param {string} code - Setting code (e.g. 'SLOGAN')
 * @param {string} lang - Language code (e.g. 'fr')
 * @returns {Promise<string|null>} Setting value or null
 */
export const getSettingValue = async (code, lang = 'fr') => {
    try {
        const response = await fetch(`${API_BASE}/rest/cabaza/settings/${code}`);
        const result = await response.json();
        const success = result.success ?? result.SUCCESS;
        if (success) {
            const data = result.data ?? result.DATA;
            const key = `value_${lang}`;
            return data[key] || data[`VALUE_${lang.toUpperCase()}`] || data.value_fr || data.VALUE_FR || null;
        }
        return null;
    } catch (error) {
        console.error('Error fetching setting:', error);
        return null;
    }
};
